// Ícones SVG do site comercial — traço fino, herdam currentColor.
const S = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.7, strokeLinecap: 'round', strokeLinejoin: 'round' };

export const BrandMark = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}>
    <path d="M4 8.5h12.5v4.5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V8.5Z" />
    <path d="M16.5 9.5h2.3a2.3 2.3 0 0 1 0 4.6h-2.3" />
    <path d="M7.8 11.2l1.9 1.6-1.9 1.6" />
    <path d="M11.8 14.6h3.1" />
    <path d="M8 3.3c-.7 1 .2 1.9 0 2.9M11.5 3.3c-.7 1 .2 1.9 0 2.9" opacity=".7" />
  </svg>
);

export const IconArrow = ({ size = 17 }) => (
  <svg className="cc-arrow" width={size} height={size} viewBox="0 0 24 24" {...S}><path d="M5 12h13M13 6l6 6-6 6" /></svg>
);
export const IconMenu = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><path d="M4 7h16M4 12h16M4 17h16" /></svg>
);
export const IconStageArrow = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);

// trilhas
export const IconCloud = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><path d="M7 18a4 4 0 0 1-.5-7.97A5.5 5.5 0 0 1 17 9.5a3.5 3.5 0 0 1 .5 6.96" /><path d="M8 18h9" /></svg>
);
export const IconInfra = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><path d="M12 3l8 4.5-8 4.5-8-4.5L12 3Z" /><path d="M4 12l8 4.5 8-4.5" /><path d="M4 16.5L12 21l8-4.5" opacity=".65" /></svg>
);
export const IconK8s = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><path d="M12 3l7.5 3.5v7L12 21l-7.5-3.5v-7L12 3Z" /><circle cx="12" cy="12" r="2.4" /><path d="M12 6.5v3.1M16.8 9.2l-2.7 1.6M16.4 15.4l-2.5-1.7M7.6 15.4l2.5-1.7M7.2 9.2l2.7 1.6" opacity=".7" /></svg>
);
export const IconPipeline = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><circle cx="6" cy="6" r="2.2" /><circle cx="6" cy="18" r="2.2" /><circle cx="18" cy="12" r="2.2" /><path d="M6 8.2v7.6M8.2 6h4.3a3.3 3.3 0 0 1 3.3 3.3v.5M8.2 18h4.3a3.3 3.3 0 0 0 3.3-3.3v-.5" /></svg>
);
export const IconObs = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><path d="M3 12h3l2.5-6 4 13 2.5-7h6" /></svg>
);
export const IconTerminalSq = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><rect x="3" y="4.5" width="18" height="15" rx="2.5" /><path d="M7 9.5l2.6 2.5L7 14.5M12.5 15h4" /></svg>
);

// features
export const IconHands = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><path d="M14.5 4.5l-1.8 4.6 4.8-.3-6 10.7" /><path d="M4 13l3.5-.2L6 8.5" opacity=".7" /></svg>
);
export const IconRoute = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><circle cx="6" cy="18" r="2.2" /><circle cx="18" cy="6" r="2.2" /><path d="M8 18h6a3.5 3.5 0 0 0 0-7H10a3.5 3.5 0 0 1 0-7h4" /></svg>
);
export const IconRocket = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><path d="M5 15c-1.5 1-2 4-2 4s3-.5 4-2M14.5 5.5C17 3 20 3 20 3s0 3-2.5 5.5L12 14l-2-2 4.5-4.5Z" /><path d="M9.5 9.5L7 10l-2 2 2 .5M14.5 14.5L14 17l-2 2-.5-2" opacity=".7" /></svg>
);
export const IconClock = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 2" /></svg>
);

// planos
export const IconCheck = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><path d="M5 12.5l4.4 4.4L19 7" /></svg>
);
export const IconDash = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...S}><path d="M6 12h12" /></svg>
);
